import { FC, useEffect, useState } from "react";
import { Button, Icon } from "@smile2impress/components/relaunch";
import { CloseSmallIcon, BurgerIcon } from "@smile2impress/components";
import { useGoToBooking } from "hooks/useGoToBooking";

import { CompactMenuProps } from "./CompactMenu.types";

export const CompactMenu: FC<CompactMenuProps> = ({
    items = [],
    cta,
    index,
    activeIndex,
    onToggleMenu,
}) => {
    const { goToBooking } = useGoToBooking();
    const [isOpen, setOpen] = useState<boolean>(false);
    const [otherItemIsActive, setOtherItemIsActive] = useState<boolean>(
        activeIndex !== index && activeIndex >= 0
    );
    if (!cta.onClick && !cta.link) {
        cta.onClick = goToBooking;
    }
    const handleToggleMenu = () => {
        setOpen((prev) => {
            const newVal = !prev;
            onToggleMenu({
                index,
                items,
                isOpen: newVal,
            });
            return newVal;
        });
    };

    useEffect(() => {
        if (activeIndex !== index) {
            setOpen(false);
            setOtherItemIsActive(activeIndex !== index && activeIndex >= 0);
        } else {
            setOpen(true);
            setOtherItemIsActive(false);
        }
    }, [activeIndex]);

    return (
        <Button
            variant="ghost"
            px={0}
            onClick={handleToggleMenu}
            textAlign="center"
            w="24px"
            opacity={otherItemIsActive ? 0.4 : 1}
            mt={["0px", "0px", "-2px"]}
        >
            <Icon
                w={isOpen ? 0.7 : "24px"}
                h={isOpen ? 0.7 : "24px"}
                color={isOpen ? "text.accent" : "text.base"}
                as={isOpen ? CloseSmallIcon : BurgerIcon}
            />
        </Button>
    );
};
